import { useQuery } from '@tanstack/react-query'
import { tagsKeys } from '@/api/queryKeys'
import { fetchTag } from '@/api/tags'

/**
 * Hook to fetch a single tag by ID
 *
 * @param tagId - Tag ID (UUID)
 * @returns React Query result with tag data
 *
 * @example
 * ```tsx
 * const { data: tag, isLoading } = useTag(tagId);
 * ```
 */
export function useTag(tagId: string) {
  return useQuery({
    queryKey: tagsKeys.detail(tagId),
    queryFn: () => fetchTag(tagId),
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled: !!tagId,
  })
}
